export default {
  namespaced: true,
  state: {
    debug: false,
  },
  getters: {
    debug: s => s.debug,
  },
  mutations: {
    setDebug(s, v) {
      s.debug = v;
    },
  },
};
